import React from "react";
import { createStore } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import AgencyCoApp from "./reducers";
import Routes from "./routers";
// Removed incorrect import that shadowed global `process`

// create store
const store = createStore(
  AgencyCoApp,
  composeWithDevTools()
  // applyMiddleware(...middleware),
  // other store enhancers if any
);



function App() {
  return (
    <Provider store={store}>

      {/* {console.log("variable ", process.env)} */}
      <Routes />
    </Provider>
  );
}

export default App;
